export enum AsyncContentSubmissionStatus {
	NotSubmitted = "NotSubmitted",
	Submitted = "Submitted",
	Reviewed = "Reviewed",
}
